module.exports = __webpack_public_path__ + "img/auth-background.2fbf6b79.jpg";